import { render, staticRenderFns } from "./ContactPersonPage.vue?vue&type=template&id=6718c85e&scoped=true&"
var script = {}
import style0 from "./ContactPersonPage.vue?vue&type=style&index=0&id=6718c85e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6718c85e",
  null
  
)

export default component.exports